(function () {
  'use strict';

  if (window.FellinoraDecideSectionLoaded) {
    return;
  }

  window.FellinoraDecideSectionLoaded = true;

  var reduceMotion  = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hoverCapable  = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ─── helpers ──────────────────────────────────────────────── */
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  /* ─── Polaroid tilt ────────────────────────────────────────── */
  var MAX_TILT   = 12;    // degrees — softer than small tiles
  var TILT_SCALE = 1.04;
  var LERP_SPEED = 0.09;  // slightly slower for the bigger card feel

  function initPolaroidTilt(polaroid) {
    if (reduceMotion.matches || !hoverCapable.matches) return;

    /* inject gloss into the media area only */
    var media = polaroid.querySelector('.fds-polaroid__media');
    var gloss  = document.createElement('span');
    gloss.className = 'fds-polaroid__gloss';
    gloss.setAttribute('aria-hidden', 'true');
    if (media) media.appendChild(gloss);

    var rafId  = null;
    var isOver = false;
    var curX = 0, curY = 0;
    var tgtX = 0, tgtY = 0;
    var glossNX = 0.5, glossNY = 0.5;
    var tgtGlossNX = 0.5, tgtGlossNY = 0.5;

    function tick() {
      curX = lerp(curX, tgtX, LERP_SPEED);
      curY = lerp(curY, tgtY, LERP_SPEED);
      glossNX = lerp(glossNX, tgtGlossNX, LERP_SPEED);
      glossNY = lerp(glossNY, tgtGlossNY, LERP_SPEED);

      var settled = !isOver
        && Math.abs(curX) < 0.04
        && Math.abs(curY) < 0.04;

      if (settled) {
        curX = 0; curY = 0;
        polaroid.style.transform = '';
        polaroid.style.boxShadow = '';
        if (gloss) gloss.style.opacity = '0';
        rafId = null;
        return;
      }

      var sc = isOver ? TILT_SCALE : 1;
      polaroid.style.transform =
        'perspective(900px)'
        + ' rotateX(' + curX.toFixed(3) + 'deg)'
        + ' rotateY(' + curY.toFixed(3) + 'deg)'
        + ' scale(' + sc + ')';

      /* shadow shifts with tilt to simulate real light */
      var sx = (-curY * 0.5).toFixed(1);
      var sy = ( curX * 0.5 + 8).toFixed(1);
      polaroid.style.boxShadow =
        sx + 'px ' + sy + 'px 28px rgba(0,0,0,0.20),'
        + ' 6px 6px 0 var(--fds-ink)';

      /* gloss radial highlight follows cursor */
      if (gloss) {
        gloss.style.background =
          'radial-gradient(circle at '
          + (glossNX * 100).toFixed(1) + '% '
          + (glossNY * 100).toFixed(1) + '%, '
          + 'rgba(255,255,255,0.38) 0%, transparent 65%)';
      }

      rafId = requestAnimationFrame(tick);
    }

    polaroid.addEventListener('mouseenter', function () {
      isOver = true;
      if (gloss) gloss.style.opacity = '1';
      if (!rafId) rafId = requestAnimationFrame(tick);
    });

    polaroid.addEventListener('mousemove', function (e) {
      var rect = polaroid.getBoundingClientRect();
      var nx = (e.clientX - rect.left)  / rect.width;
      var ny = (e.clientY - rect.top)   / rect.height;

      tgtY =  (nx - 0.5) * MAX_TILT * 2;
      tgtX = -(ny - 0.5) * MAX_TILT * 2;
      tgtGlossNX = nx;
      tgtGlossNY = ny;

      if (!rafId) rafId = requestAnimationFrame(tick);
    });

    polaroid.addEventListener('mouseleave', function () {
      isOver = false;
      tgtX = 0; tgtY = 0;
      tgtGlossNX = 0.5; tgtGlossNY = 0.5;
      if (gloss) gloss.style.opacity = '0';
      if (!rafId) rafId = requestAnimationFrame(tick);
    });
  }

  /* ─── Stagger delays ───────────────────────────────────────── */
  function setDelays(section) {
    section.querySelectorAll('[data-fds-stagger]').forEach(function (item) {
      var delay = Number(item.getAttribute('data-fds-delay')) || 0;
      item.style.setProperty('--fds-delay', delay + 'ms');
    });
  }

  /* ─── Scroll reveal ────────────────────────────────────────── */
  function reveal(section) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('fds-is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        section.classList.add('fds-is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  }

  /* ─── Section init ─────────────────────────────────────────── */
  function initSection(section) {
    if (!section) return;
    setDelays(section);
    reveal(section);
    var polaroid = section.querySelector('.fds-polaroid');
    if (polaroid) initPolaroidTilt(polaroid);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fds-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
